export const mapBoxKey =
  "pk.eyJ1IjoidG9tLWlucmFuZ2UiLCJhIjoiY2t5aWhlejVqMXlvYjJvdXJhb3Q2bGdjdCJ9.Uy8CpeGLbj_qeKsDYR0BaA";
